import { Grid, styled } from "@mui/material";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormInputField from "@rf-l2/form/text-fields/MxFormInputField";
import MxFormErrorIconsMessage from "@rf-l2/form/MxFormErrorIconsMessage";
import { CPropertyBuildingFormKeys } from "@rf/property/module/components/property-form/util/schemas/building-form/building.schema";
import { useBuildingDetail } from "../../context/BuildingDetailContext";

const PropertyBuildingNameInput = () => {
  const { nameBuilding, indexBuilding } = useBuildingDetail();

  return (
    <ContentUnit item xs={12}>
      <MxFormFieldController
        name={`${nameBuilding}.${CPropertyBuildingFormKeys.name}`}
        withreacthookform={1}
      >
        <Grid container spacing={1} alignItems="center">
          <Grid item xs={10}>
            <MxFormInputField placeholder="Edificio 1" />
          </Grid>
          <Grid item xs="auto">
            <MxFormErrorIconsMessage />
          </Grid>
        </Grid>
      </MxFormFieldController>
    </ContentUnit>
  );
};

export default PropertyBuildingNameInput;
const ContentUnit = styled(Grid)(({ theme }) => ({
  height: 40,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& .MuiOutlinedInput-root": {
    borderRadius: 0,

    "*": {
      border: `0px`,
      color: "white",
      "::placeholder": {
        color: "white",
        opacity: 0.6
      }
    }
  }
}));
